import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";

const pageSize = 10; // Number of items per page

export default function AnnouncementTable(props) {
  const { tableData, editRoute, deleteRoute, canApprove, onApprove, onReject, canUpdate, canDelete } = props;

  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total number of pages
  const totalPages = Math.ceil(tableData.length / pageSize);

  // Calculate the index range of the current page
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  // Get the current page's data
  const currentData = tableData.slice(startIndex, endIndex);

  // Handle previous page
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // Handle next page
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      approved: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300",
      pending: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300",
      rejected: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300",
      draft: "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300",
    };
    return (
      <span
        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          statusColors[status] || statusColors.pending
        }`}
      >
        {status?.charAt(0).toUpperCase() + status?.slice(1)}
      </span>
    );
  };

  const getNotificationLabel = (notification) => {
    const labels = {
      0: "All",
      1: "VL",
      2: "Vnaya",
      3: "Creed",
      4: "ASI",
    };
    return labels[notification] || "All";
  };

  return ( 
    <>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 px-4 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        <div className="flex items-center gap-x-3">
                          <span>Id</span>
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="px-12 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        <span>Image</span>
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        <span>Posted By</span>
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        <span>Title</span>
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        Type
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        Notification
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        <span>Date</span>
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-[#444] rtl:text-right dark:text-gray-400"
                      >
                        <span className="">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-900">
                    {tableData && tableData.length > 0 ? (
                      <>
                        {currentData.map((data, index) => (
                          <tr key={data.id || index}>
                            <td className="whitespace-nowrap px-4 py-4 text-sm font-medium text-[#444]">
                              <div className="inline-flex items-center gap-x-3">
                                <div className="flex items-center gap-x-2">
                                  <div>
                                    <h2 className="font-medium text-[#444] dark:text-white">
                                      {data.id}
                                    </h2>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="whitespace-nowrap py-4 text-sm font-medium text-[#444]">
                              <div className="inline-flex items-center rounded-md px-2 dark:bg-gray-800">
                                {data.image ? (
                                  <img
                                    className="h-16 w-[100px] rounded-md object-cover"
                                    src={data.image}
                                    alt={data.title}
                                  />
                                ) : (
                                  <div className="h-16 w-[100px] rounded-md bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                                    <span className="text-xs text-[#444]">No Image</span>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-[#444] dark:text-gray-300">
                              {data.postedByName || "HR"}
                            </td>
                            <td className="px-4 py-4 text-sm text-[#444] dark:text-gray-300">
                              <div className="max-w-xs truncate" title={data.title}>
                                {data.title}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-[#444] dark:text-gray-300">
                              {data.announcementType || "General"}
                            </td>
                            <td className="px-4 py-4 text-sm text-[#444] dark:text-gray-300">
                              {getStatusBadge(data.status)}
                            </td>
                            <td className="px-4 py-4 text-sm text-[#444] dark:text-gray-300">
                              {getNotificationLabel(data.notification)}
                            </td>
                            <td className="px-4 py-4 text-sm text-[#444] dark:text-gray-300">
                              {data.createdAt
                                ? new Date(data.createdAt).toLocaleDateString("en-US")
                                : "-"}
                            </td>
                            <td className="whitespace-nowrap px-4 py-4 text-sm">
                              <div className="flex items-center gap-1.5">
                                {canApprove && data.status === "pending" && (
                                  <>
                                    <button
                                      onClick={() => onApprove(data.id)}
                                      className="flex items-center justify-center rounded-lg bg-green-50 p-2 text-green-600 transition-all duration-200 hover:bg-green-100 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-1"
                                      title="Approve"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        className="h-4 w-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                      </svg>
                                    </button>
                                    <button
                                      onClick={() => onReject(data.id)}
                                      className="flex items-center justify-center rounded-lg bg-red-50 p-2 text-red-600 transition-all duration-200 hover:bg-red-100 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1"
                                      title="Reject"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        className="h-4 w-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                      </svg>
                                    </button>
                                  </>
                                )}
                                <Link to={`/admin/announcements/view/${data.id}`}>
                                  <button
                                    className="flex items-center justify-center rounded-lg bg-indigo-50 p-2 text-indigo-600 transition-all duration-200 hover:bg-indigo-100 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
                                    title="View"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth="2"
                                      stroke="currentColor"
                                      className="h-4 w-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                                      />
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                      />
                                    </svg>
                                  </button>
                                </Link>
                                {canUpdate && (
                                  <Link to={`${editRoute}/${data.id}`}>
                                    <button className="flex items-center justify-center rounded-lg bg-amber-50 p-2 text-amber-600 transition-all duration-200 hover:bg-amber-100 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        className="h-4 w-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                        />
                                      </svg>
                                    </button>
                                  </Link>
                                )}
                                {canDelete && (
                                  <Link to={`${deleteRoute}/${data.id}`}>
                                    <button className="flex items-center justify-center rounded-lg bg-red-50 p-2 text-red-600 transition-all duration-200 hover:bg-red-100 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        className="h-4 w-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                        />
                                      </svg>
                                    </button>
                                  </Link>
                                )}
                                
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="8" className="px-4 py-8 text-center text-sm text-gray-500">
                          No announcements found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
        {totalPages > 1 && (
          <div className="mt-6 gap-4 flex items-center justify-end px-4 py-4">
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
              className="flex items-center gap-x-2 rounded-md border bg-white px-5 py-2 text-sm capitalize text-[#444] transition-colors duration-200 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="h-5 w-5 rtl:-scale-x-100"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                />
              </svg>
              <span>previous</span>
            </button>

            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="flex items-center gap-x-2 rounded-md border bg-white px-5 py-2 text-sm capitalize text-[#444] transition-colors duration-200 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span>Next</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="h-5 w-5 rtl:-scale-x-100"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    </>
  );
}

